import { IonicPageModule } from 'ionic-angular';
import { NgModule } from '@angular/core';

import { VehicleAutocompletePage } from './vehicle-autocomplete';

@NgModule({
  declarations: [VehicleAutocompletePage],
  imports: [IonicPageModule.forChild(VehicleAutocompletePage)],
  exports: [VehicleAutocompletePage],
})
export class VehicleAutocompletePageModule {}



// WEBPACK FOOTER //
// ./src/pages/vehicle-autocomplete/vehicle-autocomplete.module.ts